var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [_vm.$style["mds-stepper"], _vm.classObject, _vm.sizeClass],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c(
        "div",
        { class: _vm.$style["mds-stepper__list"] },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.responsive
        ? _c("div", { class: _vm.$style["mds-stepper__active-step-summary"] }, [
            _c(
              "span",
              { class: _vm.$style["mds-stepper__active-step-label"] },
              [_vm._t("summary-label")],
              2
            ),
            _vm._v(" "),
            _c(
              "span",
              { class: _vm.$style["mds-stepper__active-step-microcopy"] },
              [_vm._t("summary-microcopy")],
              2
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }